import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DictionaryModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TapableTerminalCardModule } from '../tabbable-terminal-card/tapable-terminal-card.module';
import { CenteredScrollableContentModule } from '../centered-scrollable-content/centered-scrollable-content.module';
import { TileSelectionComponent } from './component/tile-selection.component';



@NgModule({
  declarations: [
    TileSelectionComponent
  ],
  imports: [
    CommonModule,

    DictionaryModule,
    TapableTerminalCardModule,
    ApplicationClientCommonModule,
    CenteredScrollableContentModule,
    CommonTranslationModule,
    FormsModule,
    ReactiveFormsModule

  ],
  exports:[
    TileSelectionComponent
  ]
})
export class TileSelectionModule { }
